import { Table } from "flowbite-react";
import React, { useState, useEffect } from "react";
import axios from "axios";
import jsPDF from "jspdf"; // Import jsPDF
import "jspdf-autotable"; // For table functionality
import { IoMdDownload } from "react-icons/io";
import { Button } from "flowbite-react";

function Cdelivery_chellan({ orderid, Sub_Order_id }) {
  const [completed_quantity, Setcompleted_quantity] = useState({
    updated_marker: [],
    total_quantity: 0,
  });
  const [Order, setOrder] = useState({ sizevarientwithquantity: "", buyer_name: "", colour_name: "", style_name: "", orderdate: "", total_piece: 0, cutorderno: "", pono: "", noofbales: "", delivery_date: "" });
  const [Suborder, setSuborder] = useState({});
  const [Marker, setMarker] = useState({});

  useEffect(() => {
    fetch_completed_quantity();
    fetchorder();
    fetchsuborder();
    fetchmarker();
  }, []);

  const fetch_completed_quantity = async () => {
    try {
      const response = await axios.get(`cutting_dc/fetch_complete_quantity/${orderid}/${Sub_Order_id}`);
      const completedquantityData = response.data;
      Setcompleted_quantity(completedquantityData);
    } catch (error) {
      console.error("Error fetching completed_quantity data:", error);
    }
  };
  const fetchorder = async () => {
    try {
      const response = await axios.get(`order/orders/${orderid}`);
      const OrderData = response.data;
      setOrder({
        orderdate: OrderData.order_date,
        total_piece: OrderData.total_piece,
        cutorderno: OrderData.cut_order_no,
        pono: OrderData.job_no,
        noofbales: OrderData.no_of_bales,
        buyer_name: OrderData.buyer_name,
        colour_name: OrderData.colour_name,
        style_name: OrderData.style_name,
        delivery_date: OrderData.delivery_date,
        sizevarientwithquantity: OrderData.size_variant_quantity,
      });

    } catch (error) {
      console.error("Error fetching order data:", error);
    }
  };

  const fetchsuborder = async () => {
    try {
      const response = await axios.get(`order/suborders_by_suborder_id/${Sub_Order_id}`);
      const SubOrderData = response.data.suborder;
      setSuborder(SubOrderData);


    } catch (error) {
      console.error("Error fetching suborder data:", error);
    }
  };
  const fetchmarker = async () => {
    try {
      const response = await axios.get("master/size_variants");
      const markerData = response.data;
      setMarker(markerData);
      // console.log(Marker)
    } catch (error) {
      console.error("Error fetching Marker data:", error);
    }
  };
  // Generate PDF for completed_quantity array
  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(8);
  
    const formatDate = (date) => {
      const d = new Date(date);
      return isNaN(d.getTime()) ? "Invalid Date" : d.toLocaleDateString("en-GB");
    };
    const formatDateTime = (date) => {
      const d = new Date(date);
      return isNaN(d.getTime()) 
          ? "Invalid Date" 
          : `${d.toLocaleDateString("en-GB")} ${d.toLocaleTimeString("en-GB", { hour12: true })}`;
  };
  
    console.log(Suborder[0].colour_name);
    const details = [
      { label: "Buyer Name", value: Order.buyer_name },
      { label: "Colour", value: Suborder[0].colour_name },
      { label: "Po No", value: Order.pono },
      { label: "Order No", value: Order.cutorderno },
      { label: "Style", value: Order.style_name },
      { label: "Total Piece", value: Suborder[0].total_piece },
      { label: "Order Date", value: formatDate(Order.orderdate) },
      { label: "Delivery Date", value: formatDate(Order.delivery_date) },
    ];
  
    const columnPositions = [10, 50, 90, 140];
    let yPosition = 20;
  
    for (let row = 0; row < 2; row++) {
      for (let col = 0; col < 4; col++) {
        const index = row * 4 + col;
        if (details[index]) {
          doc.text(details[index].label + ":", columnPositions[col], yPosition);
          doc.text(
            details[index].value ? details[index].value.toString() : "N/A",
            columnPositions[col] + 20,
            yPosition
          );
        }
      }
      yPosition += 10;
    }
  
    yPosition += 10;
  
    doc.setFontSize(10);
    doc.text("Order Table", 10, yPosition);
    yPosition += 5; // Space before the table
    // Table 1: Size Variant Table
    doc.autoTable({
      startY: yPosition,
      head: [["Size", ...Object.keys(Suborder[0].size_variant_quantity)]],
      body: [["Quantity", ...Object.values(Suborder[0].size_variant_quantity)]],
      theme: "grid",
      margin: { top: 30, left: 10, right: 10, bottom: 20 },
      headStyles: { fillColor: [87, 239, 184], textColor: [255, 255, 255] }, // Green header with white text
      bodyStyles: { fillColor: [240, 255, 240] }, // Light green body rows
    });
  
    const firstTableHeight = doc.lastAutoTable?.finalY || 20; // Ensure proper spacing

    doc.setFontSize(10);
    doc.text(`Completed Table (${formatDateTime(new Date())})`, 10, firstTableHeight+15);
    // Table 2: Completed Quantity Table
    const sizeHeaders = ["Size", ...completed_quantity.updated_marker.map((item) => item.size)];
    const sizeBody = [
      ["Quantity", ...completed_quantity.updated_marker.map((item) => item.quantity)],
    ];
  
    doc.autoTable({
      startY: firstTableHeight + 20,
      head: [sizeHeaders], // Sizes as table headers
      body: sizeBody, // Quantities as a single row
      theme: "grid",
      margin: { left: 10 },
      headStyles: { fillColor: [87, 239,184], textColor: [255, 255, 255] }, // Same green header
      bodyStyles: { fillColor: [240, 255, 240] }, // Same light green body
    });
  
    // Save PDF
    doc.save(`Cutting_DC_${orderid}_${Sub_Order_id}.pdf`);
  };
  


  return (
    <>
      <div className="overflow-x-auto mt-4">
        {/* <Button className="bg-sidebar-color text-white mb-3" size="xs" onClick={downloadPDF}> <IoMdDownload className="mr-1" />  Download PDF</Button> */}
        <Table className="border">
          <Table.Head className="border">
            <Table.HeadCell className="border">Size</Table.HeadCell>
            {completed_quantity.updated_marker && completed_quantity.updated_marker.length > 0 ? (
              completed_quantity.updated_marker.map((item, index) => (
                <Table.HeadCell key={index} className="border">{item.size}</Table.HeadCell>
              ))
            ) : (
              <Table.HeadCell>No sizes available</Table.HeadCell>
            )}
            <Table.HeadCell>Total</Table.HeadCell>
          </Table.Head>
          <Table.Body className="divide-y">
            <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
              <Table.Cell className="border whitespace-nowrap font-medium text-gray-900 dark:text-white">
                {'Quantity'}
              </Table.Cell>
              {completed_quantity.updated_marker && completed_quantity.updated_marker.length > 0 ? (
                completed_quantity.updated_marker.map((item, index) => (
                  <Table.Cell key={index} className="border">{item.quantity}</Table.Cell>
                ))
              ) : (
                <Table.Cell>No quantities available</Table.Cell>
              )}
              <Table.Cell className="border">{completed_quantity.total_quantity || 0}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    </>
  );
};

export default Cdelivery_chellan;
